import { render, staticRenderFns } from "./introductionPage.vue?vue&type=template&id=258d4a50&scoped=true"
import script from "./introductionPage.vue?vue&type=script&lang=js"
export * from "./introductionPage.vue?vue&type=script&lang=js"
import style0 from "./introductionPage.vue?vue&type=style&index=0&id=258d4a50&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258d4a50",
  null
  
)

export default component.exports